import React from 'react';

const TextAreaField = ({ label, name, value, onChange, placeholder, register, defaultValue, explanation, rules, error }) => {

    const reg = register ? {...register(name, rules)} : {
        onChange,
        name,
        value
    };

    return (
        <div className='mb-3 flex w-full'>
            <label className='w-1/6 text-uidarker font-medium pr-6 text-right'>{label} {rules && <span className='text-red'>*</span>}</label>
            <div className='flex flex-col w-full max-w-xs'>
            <textarea
                {...reg}
                placeholder={placeholder}
                defaultValue={defaultValue}
                className={`bg-uilight border-solid border-2 border-uidark rounded-lg py-1 px-4 w-full max-w-xs ${error ? 'border border-red focus:outline-red' : ''}`}
            />
            {explanation && (
                <span className='text-brandDarkBlue text-xs text-gray-500 my-1 max-w-xs'>{explanation}</span>
            )}
            {error && <span className='text-red text-xs'>{error}</span>}
            </div>
        </div>        
    )
};

export default TextAreaField;